import { Group, Lock, Public as PublicIcon } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EventTypeEnum } from 'src/shared/models/enums/eventType.enum';

const typeMap: Record<EventTypeEnum, { icon: React.ReactNode; label: string }> = {
  public: { icon: <PublicIcon fontSize='small' />, label: 'event:eventType.public' },
  nonPublic: { icon: <Group fontSize='small' />, label: 'event:eventType.nonPublic' },
  onlyMembers: { icon: <Lock fontSize='small' />, label: 'event:eventType.onlyMembers' },
};

type EventMeEventTypeProps = {
  eventType: EventTypeEnum;
};
export const EventMeEventType = (props: EventMeEventTypeProps) => {
  const { eventType } = props;
  const { t } = useTranslation();
  return (
    <Box display='flex' alignItems='center' justifyContent='start' sx={{ color: 'text.secondary' }}>
      {typeMap[eventType].icon}
      <Typography variant='body1' ml={1}>
        {t(typeMap[eventType].label)}
      </Typography>
    </Box>
  );
};
